/**
 * User tracking utilities for monitoring services
 * These functions are used to track user information in monitoring services
 */

import { clearUser, setUser } from "./monitoring";

/**
 * Set user information in all monitoring services
 * @param user User information to set
 */
export function setMonitoringUser(user: {
  userId: number;
  email?: string;
  firstName?: string;
  lastName?: string;
}): void {
  // Format the user object for monitoring services
  setUser({
    id: user.userId.toString(),
    email: user.email,
    username:
      user.firstName && user.lastName
        ? `${user.firstName} ${user.lastName}`
        : undefined,
  });
}

/**
 * Clear user information from all monitoring services
 */
export function clearMonitoringUser(): void {
  clearUser();
}
